<template>
  <div id="products" class="px-4 pb-4">
    <v-dialog v-model="showCsvModal">
      <v-card>
        <v-card-title>
          Import Products
        </v-card-title>
        <v-card-text class="text-left">
          <div>
            <!-- <CSVBoxButton
              :licenseKey="licenseKey"
              :user="user"      
              :onImport="onImport"
              :options="options">
              Upload File
            </CSVBoxButton> -->
            <!-- <csv-import
              @close="showCsvModal = false"
              url="/products/create-products"
              :map-fields="fieldMapping"
              :canIgnore="true"
            >
            </csv-import> -->
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="d-flex justify-end my-2">
      <!-- <v-btn color="primary" @click="showCsvModal = true"
        >Import Products</v-btn
      > -->
      <CSVBoxButton
        :licenseKey="licenseKey"
        :user="user"      
        :onImport="onImport"
        :options="options">
        <button class="px-2 w-100 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary">Import Products</button>
      </CSVBoxButton>
    </div>
    <product-list
      @enable-action="disabled = false"
      @disable-action="disabled = true"
    />
  </div>
</template>
<script>
import ProductList from "@/components/product_management/ProductList";
import CsvImport from "@/components/CsvImport.vue";
import { CSVBoxButton } from '@csvbox/vuejs';
import VueCookie from "vue-cookie";
export default {
  components: {
    ProductList,
    CsvImport,
    CSVBoxButton
  },
  mounted() {
    this.options = {
      request_headers: {
        "Content-Type": "application/json",
        "Authorization": 'Bearer'+VueCookie.get("token")
      }
    }
  },
  data: () => ({
    licenseKey: 'lCb7rWe2mwdfEGK1qvpFfpVuUB7icj',
    user: {
      user_id: 'default123',
    },
    disabled: true,
    showCsvModal: false,
    actions: [
      {
        value: 1,
        text: "Update Status"
      },
      {
        value: 2,
        text: "Update Brand"
      },
      {
        value: 3,
        text: "Update Supplier"
      }
    ],
    csv: null,
    items: [],
    options: {},
    fieldMapping: [
      {
        key: "name",
        value: "name",
        required: true
      },
      {
        key: "description",
        value: "description",
        required: true
      },
      {
        key: "product_brand_id",
        value: "product_brand_id",
        required: true
      },
      {
        key: "supplier_id",
        value: "supplier_id",
        required: true
      },
      {
        key: "manufacturer_id",
        value: "manufacturer_id",
        required: true
      },
      {
        key: "quantity",
        value: "quantity",
        required: false
      },
      {
        key: "size",
        value: "size",
        required: false
      },
      {
        key: "colour",
        value: "colour",
        required: false
      },
      {
        key: "amount",
        value: "amount",
        required: true
      },
      {
        key: "images",
        value: "images",
        required: true
      },
      {
        key: "weight",
        value: "weight",
        required: false
      },
      {
        key: "product_subcategories",
        value: "product_subcategories",
        required: true
      },
      {
        key: "shipment_profile_id",
        value: "shipment_profile_id",
        required: true
      }
    ]
  }),
  methods: {
    onImport: function (result, data) {    
       if(result) {
          console.log("success");
          console.log(data.row_success + " rows uploaded");
          //custom code
      } else {
          console.log("fail");
          //custom code
      }
    }
  },
  computed: {}
};
</script>
